module.exports = __webpack_public_path__ + "static/media/refresh_circle.f27da7de.svg";